export function isFunction<T>(object: T) {
  return typeof object === 'function';
}
